
<template>
  <CreateNewItemInCatalog
    app_mode
    :btn_text="item ? '' : $t('Catalog.CreatePosition')"
    :create="item ? editItem : createNewCart"
    data-qa="create-new-item-in-catalog"
    :dialog_name="item ? $t('Common.Edit') : ''"
    get-measur="setMeasurements"
    :item="item"
    @searching="searching"/>
</template>
<script>
import CreateNewItemInCatalog from 'components/common/dialogs/CreateNewItemInCatalog.vue'

/* eslint-disable vue/no-mutating-props */
import { ApplicationRowDraft } from '@/types/application_draft.js'
import CartApi from '@/api/cartItemsApi'
const cart_api = new CartApi()
import { mapGetters } from 'vuex'
export default {
  name: 'editCartResource',
  data() {
    return {
    }
  },
  props: {
    cart: Array,
    item: Object,
    app: Object,
    deselect: {
      type: Function,
      default: () => {}
    },
    // selected: Array
  },
  computed: {
    ...mapGetters({
      cartItems: 'getCartItems'
    }),
  },
  methods: {
    searching(val) {
      this.$emit('searching', val)
    },
    async createNewCart( name, measur, additional, category_code ) {
      if (this.app) {
        let  app = ApplicationRowDraft.createdRow(name, measur, additional, category_code, this.app)
        await app.addNewToApp()
          .then (res =>  {
            if (res) {
              if (Array.isArray(res)) {
                res.forEach(resItem => {
                  this.app.rows.push( resItem )
                })
              } else {
                this.app.rows.push( res )
              }
            } else {
              this.$notice.info({
                title: this.$t('Common.ErrorTitle'),
                message: this.$t('Errors.STHWrong'),
                showClose: true,
                progress: true,
                duration: 10
              })
              return
            }
          })
      } else {
        return await cart_api.createCartMutation(name, category_code, +measur?.id || +measur, additional)
          .then( res => {
            if (!res) { return this.$log_error('createCartMutation') }
            this.$emit('update:cart', this.$store.getters['getCartItems'])
            this.deselect(this.item)
            return res
          })
      }
    },
    async editItem( name, measur, additional, category_code, resourceId ) {
      if (this.item.rowId) {
        let item = new ApplicationRowDraft(this.item, this.app)
        await item.editDraftResource(name, measur, additional, category_code, resourceId).then(res => {
          let result = res?.data?.changeRowsInDraft
          if ( result?.length && result[0]?.id) {
            result = result[0]
            this.item.unit = result?.unit
            this.item.resourceName = result?.resourceName
            this.item.name = result?.resourceName
            this.item.categoryId = result?.resource?.category
            this.item.description = result?.description
          }
        })
      } else {
        let cart_item_index = this.cartItems.findIndex(item => {
          return item?.id == this.item?.id
        })

        if (cart_item_index > -1) {
          await cart_api.deleteCartItemsMutation([this.cartItems[cart_item_index].id])
        }
        await this.createNewCart( name, measur, additional,category_code )
      }
    }
  },
  components: {
    CreateNewItemInCatalog
  }
}
</script>
<style lang="scss" scoped>
div {
  .v-input {
    width: 100%;
  }
}
</style>
